import { Routes } from '@angular/router';

export const ONBOARDING_PATHS = {
  BASE: 'onboarding'
};

export const OnboardingRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/onboarding/onboarding.page').then((m) => m.OnboardingPage)
  }
];
